import {useRef, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {createEvent} from '../../../../../../redux/account/accountActions';
import {updateEvent} from '../../../../../../redux/event/eventActions';
import {bounceMessage} from '../../../../../../layout/userMessages/UserMessage';
import {DRAFT} from '../../utils/utils';
import store from '../../../../../../store';
import setGlobalState from '../../../../../../redux/setGlobalState';

interface FormValues {
    eventName: string;
    eventType: string;
}

type SubmitAction = 'saveAndGoToSettings' | 'saveDraft';

interface UseCreateEventSubmitProps {
    onClose: () => void;
    submitAction: SubmitAction;
}

export function useCreateEventSubmit({onClose, submitAction}: UseCreateEventSubmitProps) {
    const navigate = useNavigate();
    const {t} = useTranslation('subscriptions');
    const isSubmittingRef = useRef(false);

    const handleSubmit = async (values: FormValues) => {
        if(isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        try {
            const res = await createEvent(values.eventType);
            
            if(res?.eid) {
                const eventData = await updateEvent({title: values.eventName, ready: DRAFT, category: 0}, res.eid);
                
                if(eventData) {
                    const currentEvents = store.getState().subscription.events || [];                    
                    setGlobalState('subscription.events', [eventData, ...currentEvents]);
                }
                
                if(submitAction === 'saveAndGoToSettings') {
                    navigate(`/e/${res.eid}/event`);
                }
                onClose();
            } else {
                bounceMessage(t('errorCreatingEvent'), 'error');
            }
        } catch (error) {
            bounceMessage(t('errorCreatingEvent'), 'error');
        } finally {
            isSubmittingRef.current = false;
        }
    };

    return {handleSubmit};
}

